import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { RootState } from "../../store";
import { IEverbridgeGroupApi } from "../../common/types/everbridgeTypes";
import api from "../../api";
import { mapEverbridgeGroupsUrl } from "../../config";

export const MAP_EVERBRIDGEGROUPS: string = "mapEverbridgeGroups";

const initialState: IEverbridgeGroupApi = {
  everbridgeGroup: null,
  status: Status.IDLE,
  error: null,
};

export const mapEverbridgeGroupData = createAsyncThunk(
  MAP_EVERBRIDGEGROUPS,
  async (payload: any, { rejectWithValue }) => {
    try {
      const userId = payload?.userId;
      const groups = payload?.everbridgeGroups;
      const response = await api.post(
        mapEverbridgeGroupsUrl + `userId=${userId}`,
        groups
      );
      const mapEverbridgeGroupsResponse = response.data;
      return mapEverbridgeGroupsResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const mapEverbridgeGroupsSlice = createSlice({
  name: MAP_EVERBRIDGEGROUPS,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mapEverbridgeGroupData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(mapEverbridgeGroupData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.everbridgeGroup = action.payload;
      })
      .addCase(mapEverbridgeGroupData.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.mapEverbridgeGroupsApi;

export const reducer = mapEverbridgeGroupsSlice.reducer;
